import KurpfalzLogo from "@/components/KurpfalzLogo";

const CKP_LOGO = "/ck-partners-logo.png";

/**
 * Combined brand lockup:
 *   Kurpfalz Automation  |  eine Marke von  [CK & Partners logo]
 *
 * The "eine Marke von CK & Partners" part hides below `md` in compact contexts
 * (e.g. header) to protect mobile space, but is always shown in the footer.
 */
export const BrandLockup = ({ dark = false, compact = false, className = "" }) => {
  const divider = dark ? "bg-white/20" : "bg-slate-300";
  const label = dark ? "text-white/60" : "text-slate-500";

  return (
    <div className={`flex items-center gap-4 sm:gap-5 ${className}`}>
      <KurpfalzLogo dark={dark} />

      <div
        className={`items-center gap-3 sm:gap-4 ${compact ? "hidden md:flex" : "flex"}`}
      >
        <span className={`h-9 w-px ${divider}`} aria-hidden="true" />
        <div className="flex flex-col leading-tight">
          <span className={`text-[10px] uppercase tracking-[0.18em] ${label}`}>
            eine Marke von
          </span>
          <img
            src={CKP_LOGO}
            alt="CK & Partners"
            className="mt-2.5 h-8 sm:h-9 w-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default BrandLockup;
